import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image - Decalee vers la droite */}
      <div 
        className="absolute inset-0 bg-cover bg-no-repeat"
        style={{
          backgroundImage: 'url(https://devgilles.wptotem.com/wp-content/uploads/2024/03/IMG_9885_www.vincentphotographie.com_.jpg)',
          backgroundPosition: '70% center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0C0A09]/95 via-[#1C1917]/80 to-[#0C0A09]/40" />

      {/* Gold Dust Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-[#D4AF37] rounded-full opacity-30"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animation: `particle ${8 + Math.random() * 4}s linear infinite`,
            }}
          />
        ))}
      </div>

      {/* Content - Text Only, Left Aligned */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-32 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="max-w-xl"
        >
          <p className="text-[#D4AF37] uppercase tracking-[0.3em] text-sm font-medium mb-6">
            Expansion de Conscience
          </p>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#FAFAF9] leading-tight mb-6">
            Libérez Votre<br />
            <span className="italic text-[#D4AF37]">Potentiel</span>{' '}
            <span className="text-[#FAFAF9]">Illimité</span>
          </h1>
          <p className="text-[#A8A29E] text-lg md:text-xl max-w-lg leading-relaxed mb-10">
            Transformez vos blessures en trésors. Accueillez l'alchimie intérieure 
            pour révéler votre essence la plus lumineuse.
          </p>
          
          {/* Stats Bar */}
          <div className="flex flex-wrap gap-8 mb-10 py-6 border-t border-b border-[#D4AF37]/20">
            <div>
              <p className="font-display text-3xl text-[#D4AF37]">26+</p>
              <p className="text-[#A8A29E] text-sm uppercase tracking-wider">ans</p>
            </div>
            <div>
              <p className="font-display text-3xl text-[#D4AF37]">25K+</p>
              <p className="text-[#A8A29E] text-sm uppercase tracking-wider">clients</p>
            </div>
            <div>
              <p className="font-display text-3xl text-[#D4AF37]">1M+</p>
              <p className="text-[#A8A29E] text-sm uppercase tracking-wider">vues</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#quiz"
              data-testid="hero-cta-quiz"
              className="bg-gradient-to-r from-[#D4AF37] to-[#AA8C2C] text-white rounded-full px-8 py-4 uppercase tracking-widest text-sm font-bold hover:shadow-[0_0_25px_rgba(212,175,55,0.5)] transition-all duration-300 text-center"
            >
              Découvrir mon Dauphin Guide
            </a>
            <a
              href="#about"
              data-testid="hero-cta-about"
              className="border border-[#D4AF37]/50 text-[#D4AF37] bg-transparent rounded-full px-8 py-4 uppercase tracking-widest text-sm font-medium hover:bg-[#D4AF37]/10 transition-all duration-300 text-center"
            >
              En savoir plus
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2"
      >
        <ChevronDown className="text-[#D4AF37]" size={32} />
      </motion.div>
    </section>
  );
};

export default Hero;
